// Shared donation/support constants used by the supporter page and the
// homepage supporter banner. Voluntary PayPal donations replace the former
// Premium plans.
// NOTE: The actual charge currency (USD) is configured in the PayPal donate
// button itself; currency_code is appended as a hint for the checkout.
export const PAYPAL_DONATE_URL = 'https://www.paypal.com/donate/?hosted_button_id=ZENRQGC5ZGV4E&currency_code=USD';
